import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowRight, Plus } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

export const HeroContent = () => {
  const { isAuthenticated } = useAuth();
  return (
    <div>
      <span className="inline-block py-1 px-3 rounded-full bg-igbanwo-mint/10 text-igbanwo-mint text-sm font-medium mb-5">
        Local Food Exchange Platform
      </span>

      <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
        Share Your <span className="text-igbanwo-mint">Homegrown</span> Harvests
        With Your Community
      </h1>
      <p className="text-muted-foreground text-lg md:text-xl mb-10 max-w-2xl mx-auto">
        Trade your garden's abundance for other local produce. Build a
        sustainable food system in your neighbourhood.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
        <Link to="/browse">
          <Button variant="mint" className="w-full sm:w-auto px-8 py-6 text-lg">
            Browse Offerings
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </Link>

        {isAuthenticated ? (
          <Link to="/create-listing">
            <Button
              variant="outline"
              className="w-full sm:w-auto border-igbanwo-mint/20 hover:border-igbanwo-mint/40 px-8 py-6 text-lg"
            >
              <Plus className="mr-2 h-5 w-5" />
              Create Listing
            </Button>
          </Link>
        ) : (
          <Link to="/auth?mode=register">
            <Button
              variant="outline"
              className="w-full sm:w-auto border-igbanwo-mint/20 hover:border-igbanwo-mint/40 px-8 py-6 text-lg"
            >
              Join the Community
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};